export default __webpack_public_path__ + "static/media/Varied Pop 1.6b620b80.mp3";